import { Store } from 'vuex'
import { emitter } from '@kwixeo/interface-vue'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.TicketsCategoryCreated',
    callback: (category: KwixeoTickets.Category): void => {
      store.dispatch('tickets/setCategory', category)
    }
  },
  {
    name: '.TicketsCategoryUpdated',
    callback: (category: KwixeoTickets.Category): void => {
      store.dispatch('tickets/setCategory', category)
    }
  },
  {
    name: '.TicketsCategoryDeleted',
    callback: (category: KwixeoTickets.Category): void => {
      store.dispatch('tickets/deleteCategory', category)
    }
  },

  {
    name: '.TicketsTagCreated',
    callback: (tag: KwixeoTickets.Tag): void => {
      store.dispatch('tickets/setTag', tag)
    }
  },
  {
    name: '.TicketsTagUpdated',
    callback: (tag: KwixeoTickets.Tag): void => {
      store.dispatch('tickets/setTag', tag)
    }
  },
  {
    name: '.TicketsTagDeleted',
    callback: (tag: KwixeoTickets.Tag): void => {
      store.dispatch('tickets/deleteTag', tag)
    }
  },

  {
    name: '.TicketsTemplateCreated',
    callback: (template: KwixeoTickets.Template): void => {
      store.dispatch('tickets/setTemplate', template)
    }
  },
  {
    name: '.TicketsTemplateUpdated',
    callback: (template: KwixeoTickets.Template): void => {
      store.dispatch('tickets/setTemplate', template)
    }
  },
  {
    name: '.TicketsTemplateDeleted',
    callback: (template: KwixeoTickets.Template): void => {
      store.dispatch('tickets/deleteTemplate', template)
    }
  },

  {
    name: '.TicketsTicketCreated',
    callback: (ticket: KwixeoTickets.Ticket): void => {
      emitter.emit('ticketCreated', ticket)
    }
  },
  {
    name: '.TicketsTicketUpdated',
    callback: (ticket: KwixeoTickets.Ticket): void => {
      emitter.emit('ticketUpdated', ticket)
    }
  },
  {
    name: '.TicketsTicketDeleted',
    callback: (ticket: KwixeoTickets.Ticket): void => {
      emitter.emit('ticketDeleted', ticket)
    }
  },

  {
    name: '.TicketsCommentCreated',
    callback: (comment: KwixeoTickets.Comment): void => {
      emitter.emit('ticketsCommentCreated', comment)
    }
  },
  {
    name: '.TicketsCommentUpdated',
    callback: (comment: KwixeoTickets.Comment): void => {
      emitter.emit('ticketsCommentUpdated', comment)
    }
  },
  {
    name: '.TicketsCommentDeleted',
    callback: (comment: KwixeoTickets.Comment): void => {
      emitter.emit('ticketsCommentDeleted', comment)
    }
  }
])
